import { __assign } from 'tslib';
import React, { useState, useEffect } from 'react';
import { debounce } from 'lodash-es';
import 'clsx';
import './../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Spacer from '../../util/Spacer/Spacer.js';
import { PROGRESS_STEP, FULL_PROGRESS_PERCENTAGE } from '../constants.js';
import FileComponent from './FileComponent.js';

var FileContainer = function (_a) {
    var file = _a.file, deleteFile = _a.deleteFile, hasFileProcessing = _a.hasFileProcessing;
    var _b = useState({
        intervalId: 0,
        progress: PROGRESS_STEP
    }), progressConfig = _b[0], setProgressConfig = _b[1];
    var _c = useState(false), hovered = _c[0], setHovered = _c[1];
    var onMouseEnter = debounce(function () { return setHovered(true); }, 300);
    var onMouseLeave = debounce(function () { return setHovered(false); }, 300);
    useEffect(function () {
        if (file.uploaded) {
            setProgressConfig(function (prevProgressConfig) { return (__assign(__assign({}, prevProgressConfig), { progress: FULL_PROGRESS_PERCENTAGE })); });
        }
    }, [file.uploaded]);
    return (React.createElement(Spacer, { bottom: 8 },
        React.createElement("div", { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
            React.createElement(FileComponent, { file: file, hovered: hovered, deleteFile: deleteFile, progressConfig: progressConfig, hasFileProcessing: hasFileProcessing, setProgress: setProgressConfig }))));
};

export { FileContainer };
//# sourceMappingURL=FileContainer.js.map
